var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.984 19l-1.2-1.75-0.2-0.25v-10.85c0-0.75-0.15-1.5-0.5-2.2v0 0c-0.9-1.8-2.75-2.95-4.9-2.95-2.1 0-4 1.15-4.9 2.95v0 0c-0.35 0.7-0.5 1.4-0.5 2.2v10.85l-0.2 0.25-1.15 1.75h13.55zM20.884 20h-17.4l2.3-3.3v-10.55c0-0.95 0.2-1.8 0.6-2.65 1.050-2.15 3.3-3.5 5.8-3.5s4.7 1.35 5.8 3.5c0.4 0.8 0.6 1.7 0.6 2.65v10.55l2.3 3.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.735 22c1.1 1.9 3.5 2.55 5.4 1.5 0.6-0.35 1.15-0.85 1.5-1.5h-6.9z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.eaa4b0a0.svg";
export { ForwardRef as ReactComponent };